"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCartCacheStorage = exports.getRedemptionStorage = exports.getNumberOfCartItemsStorage = exports.getTrackedOrderIdStorage = exports.getSettingStorage = exports.getRedemptionBannerShowAnimation = exports.clearCheckoutStorage = exports.getShowMapTooltipStorage = exports.getAlgoliaAnalyticsStorage = exports.getCustomerDeleteStorage = exports.getCustomerEmailStorage = exports.getSearchHistoryStorage = exports.getLastTouchpointValueStorage = exports.getLastSeenProductIdsStorage = exports.getWishlistStorage = exports.getStripeClientSecretStorage = exports.getPersonalInfoStorage = exports.getPaypalOrderIdStorage = exports.getIsVoucherExpirationReminderHidden = exports.getHideWelcomePopup = exports.getEvelinOrderIdStorage = exports.TTLStorageItem = exports.isStorageAvailable = void 0;
var algolia_analytics_storage_1 = require("./services/algolia-analytics-storage");
var browser_storage_item_1 = require("./services/browser-storage-item");
var cookie_storage_item_1 = require("./services/cookie-storage-item");
var json_storage_item_1 = require("./services/json-storage-item");
var last_seen_products_1 = require("./services/last-seen-products");
var redemption_storage_1 = require("./services/redemption-storage");
var setting_storage_1 = require("./services/setting-storage");
var ttl_storage_item_1 = require("./services/ttl-storage-item");
var wishlist_storage_1 = require("./services/wishlist-storage");
var browser_storage_item_2 = require("./services/browser-storage-item");
Object.defineProperty(exports, "isStorageAvailable", { enumerable: true, get: function () { return browser_storage_item_2.isStorageAvailable; } });
var ttl_storage_item_2 = require("./services/ttl-storage-item");
Object.defineProperty(exports, "TTLStorageItem", { enumerable: true, get: function () { return ttl_storage_item_2.TTLStorageItem; } });
__exportStar(require("./types"), exports);
var getEvelinOrderIdStorage = function () {
    return new browser_storage_item_1.BrowserStorageItem("evelin.evelinOrderId", browser_storage_item_1.StorageType.SESSION_STORAGE);
};
exports.getEvelinOrderIdStorage = getEvelinOrderIdStorage;
var getHideWelcomePopup = function () {
    return new browser_storage_item_1.BrowserStorageItem("evelin.HideWelcomeFlyout", browser_storage_item_1.StorageType.LOCAL_STORAGE);
};
exports.getHideWelcomePopup = getHideWelcomePopup;
var getIsVoucherExpirationReminderHidden = function () {
    return new browser_storage_item_1.BrowserStorageItem("evelin.isVoucherExpirationReminderHidden", browser_storage_item_1.StorageType.SESSION_STORAGE);
};
exports.getIsVoucherExpirationReminderHidden = getIsVoucherExpirationReminderHidden;
var getPaypalOrderIdStorage = function () {
    return new browser_storage_item_1.BrowserStorageItem("evelin.paypalOrderId", browser_storage_item_1.StorageType.SESSION_STORAGE);
};
exports.getPaypalOrderIdStorage = getPaypalOrderIdStorage;
var getPersonalInfoStorage = function () {
    var twoHoursInSeconds = 120 * 60;
    return new json_storage_item_1.JsonStorageItem(new cookie_storage_item_1.CookieStorageItem("evelin.personalInformation", twoHoursInSeconds));
};
exports.getPersonalInfoStorage = getPersonalInfoStorage;
var getStripeClientSecretStorage = function () {
    return new browser_storage_item_1.BrowserStorageItem("evelin.stripeClientSecret", browser_storage_item_1.StorageType.SESSION_STORAGE);
};
exports.getStripeClientSecretStorage = getStripeClientSecretStorage;
var getWishlistStorage = function () { return new wishlist_storage_1.WishlistStorage(); };
exports.getWishlistStorage = getWishlistStorage;
var getLastSeenProductIdsStorage = function () {
    return new last_seen_products_1.LastSeenProductIdsStorage();
};
exports.getLastSeenProductIdsStorage = getLastSeenProductIdsStorage;
var getLastTouchpointValueStorage = function () {
    return new browser_storage_item_1.BrowserStorageItem("evelin.lastTouchpointValue", browser_storage_item_1.StorageType.SESSION_STORAGE);
};
exports.getLastTouchpointValueStorage = getLastTouchpointValueStorage;
var getSearchHistoryStorage = function () {
    return new browser_storage_item_1.BrowserStorageItem("evelin.search.history", browser_storage_item_1.StorageType.LOCAL_STORAGE);
};
exports.getSearchHistoryStorage = getSearchHistoryStorage;
var getCustomerEmailStorage = function () {
    return new browser_storage_item_1.BrowserStorageItem("evelin.customer.email", browser_storage_item_1.StorageType.SESSION_STORAGE);
};
exports.getCustomerEmailStorage = getCustomerEmailStorage;
var getCustomerDeleteStorage = function () {
    return new browser_storage_item_1.BrowserStorageItem("evelin.customer.deleteNotificationEnabled", browser_storage_item_1.StorageType.LOCAL_STORAGE);
};
exports.getCustomerDeleteStorage = getCustomerDeleteStorage;
var getAlgoliaAnalyticsStorage = function () {
    return new algolia_analytics_storage_1.AlgoliaAnalyticsStorage();
};
exports.getAlgoliaAnalyticsStorage = getAlgoliaAnalyticsStorage;
var getShowMapTooltipStorage = function () {
    return new browser_storage_item_1.BrowserStorageItem("evelin.showMapTooltip", browser_storage_item_1.StorageType.SESSION_STORAGE);
};
exports.getShowMapTooltipStorage = getShowMapTooltipStorage;
function clearCheckoutStorage() {
    (0, exports.getEvelinOrderIdStorage)().remove();
    (0, exports.getPaypalOrderIdStorage)().remove();
    (0, exports.getStripeClientSecretStorage)().remove();
    (0, exports.getPersonalInfoStorage)().remove();
}
exports.clearCheckoutStorage = clearCheckoutStorage;
var getRedemptionBannerShowAnimation = function () {
    return new browser_storage_item_1.BrowserStorageItem("evelin.RedemptionBanner.showAnimation", browser_storage_item_1.StorageType.SESSION_STORAGE);
};
exports.getRedemptionBannerShowAnimation = getRedemptionBannerShowAnimation;
var getSettingStorage = function () { return new setting_storage_1.SettingStorage(); };
exports.getSettingStorage = getSettingStorage;
function getTrackedOrderIdStorage() {
    return new browser_storage_item_1.BrowserStorageItem("trackedOrderId", browser_storage_item_1.StorageType.LOCAL_STORAGE);
}
exports.getTrackedOrderIdStorage = getTrackedOrderIdStorage;
function getNumberOfCartItemsStorage() {
    return new browser_storage_item_1.BrowserStorageItem("numberOfCartItems", browser_storage_item_1.StorageType.LOCAL_STORAGE);
}
exports.getNumberOfCartItemsStorage = getNumberOfCartItemsStorage;
var getRedemptionStorage = function () { return new redemption_storage_1.RedemptionStorage(); };
exports.getRedemptionStorage = getRedemptionStorage;
function getCartCacheStorage() {
    var fiveMinutesInMs = 5 * 60 * 1000;
    return new ttl_storage_item_1.TTLStorageItem(new browser_storage_item_1.BrowserStorageItem("evelin.header.cartCache", browser_storage_item_1.StorageType.SESSION_STORAGE), fiveMinutesInMs);
}
exports.getCartCacheStorage = getCartCacheStorage;
//# sourceMappingURL=index.js.map